import connectInfiniteHits from "instantsearch.js/es/connectors/infinite-hits/connectInfiniteHits.js";
import { useConnector } from "../hooks/useConnector.js";
export function useInfiniteHits(props, additionalWidgetProperties) {
  return useConnector(connectInfiniteHits, props, additionalWidgetProperties);
}